import React from 'react';
import omit from 'lodash/omit';
import {
  TextField,
} from 'material-ui';

/**
 * Wrapper for the TextField component with
 * an onTouch event and custom styling
 */
export default function BasicTextInput(props) {
  const { onTouch, style } = props;
  const basicStyle = {
    display: 'block',
  };
  if (onTouch) {
    return (
      <TextField
        onChange={onTouch}
        onBlur={onTouch}
        style={{ ...basicStyle, ...style }}
        {...omit(props, ['onTouch', 'style'])}
      />
    );
  }
  return (
    <TextField
      style={{ ...basicStyle, ...style }}
      {...omit(props, 'style')}
    />
  );
}
